module.exports = __webpack_public_path__ + "img/logarithmic_nature.7648ab40.jpg";